import { Box, styled, Typography } from '@mui/material';

export const Wrapper = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'isCard' &&
    prop !== 'isCardMobileList' &&
    prop !== 'isCardMobileDetails',
})(({ theme, isCard, isCardMobileList, isCardMobileDetails }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: isCardMobileList ? 'flex-end' : 'center',
  justifyContent: isCardMobileDetails ? 'center' : 'flex-end',
  width: isCard && '45%',
  position: isCardMobileDetails && 'absolute',
  marginLeft: isCardMobileDetails && '170px',
  marginTop: isCardMobileDetails && '22px',
  [theme.breakpoints.up('md')]: {
    flexDirection: isCardMobileList && 'row',
    alignItems: 'center',
    position: isCardMobileDetails && 'static',
    marginLeft: isCardMobileDetails && 0,
    marginTop: isCardMobileDetails && 0,
  },
}));

export const VariationContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isCardMobileList',
})(({ theme, isCardMobileList }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.up('md')]: {
    marginRight: isCardMobileList && '20px',
    gap: isCardMobileList && '15px',
  },
}));

export const VariationLabel = styled(Typography, {
  shouldForwardProp: (prop) =>
    prop !== 'isCard' && prop !== 'isCardMobileDetails',
})(({ theme, isCard, isCardMobileDetails }) => {
  const getFontSize = () => {
    if (isCard) return '12px';

    if (isCardMobileDetails) return '10px';

    return '8px';
  };

  return {
    fontWeight: 500,
    color: theme.palette.colors.label,
    textTransform: 'Uppercase',
    fontSize: getFontSize(),
    order: (isCard || isCardMobileDetails) && 1,
  };
});
